define('controllers/member',[
    // Libs
    'underscore', 'backbone', 'utils', 'mustache',
    // Contoller super class
    'src/controller/controller',
    'controllers/modules/calendar/calendar',
    'controllers/modules/questionnaire/questionnaire',
    'controllers/modules/dashboard/dashboard',
    'controllers/modules/goal/goal',
    'controllers/modules/conversation/conversation',
    // Models
    'models/member/profile',
    // Views | Layout
    'views/layouts/layout-app',
    'views/app/member',
], function(
    // Libs
    _, Backbone, U, Mustache,
    // controller
    Controller,
    CalendarCtrl,
    QuestionnaireCtrl,
    DashboardCtrl,
    GoalCtrl,
    ConversationCtrl,
    // Models
    MProfile,
    // Views | Layout
    VLayoutPage,
    VMemberLayout
) {

    var MemberCtrl = Controller.extend({

        authDefault: true,
        routes: {
            '*member': 'index', // default from parent Controller
            "calendar(/)": "renderCalendar",
            "goal(/(:goalId))": "renderGoal",
            "graph(/)": "renderGraph",
            "forum(/)": "renderForum"
        },

        subRoutes: {
            dashboard: "dashboard/",
            calendar: "calendar/",
            message: "messages/",
            questionnaire: "questionnaires/",
            goal: "goal/",
            graph: "graph/",
            forum: "forum/"
        },

        initialize: function(prefix, opt) {
            opt = opt || {};
            this.profile = new MProfile();

            this.role = opt.role;

            var ctrl = this.ctrl = {
                calendar: new CalendarCtrl(
                    this.getPrefix('calendar', { userId: ':userId', groupId: ':groupId' }), {
                        layout: this.layoutCtrl,
                        url: Mustache.render(this.url.calendar, { userId: 'me' }),
                        role: this.role
                    }),
                questionnaire: new QuestionnaireCtrl(
                    this.getPrefix('questionnaire', { userId: ':userId', groupId: ':groupId', questionnaireId: ':questionnaireId' }), {
                        layout: this.layoutCtrl,
                        url: this.url.questionnaire,
                        role: this.role
                    }),
                goal: new GoalCtrl(
                    this.getPrefix('goal', { userId: ':userId', groupId: ':groupId', goalId: ':goalId' }), {
                        layout: this.layoutCtrl,
                        url: this.url.goal,
                        role: this.role
                    }),
                conversation: new ConversationCtrl(
                    this.getPrefix('message', { userId: ':userId', groupId: ':groupId' }), {
                        layout: this.layoutCtrl,
                        url: this.url.message,
                        role: this.role
                    }),
                dashboard: new DashboardCtrl(
                    this.getPrefix('dashboard', { userId: ':userId', groupId: ':groupId' }), {
                        layout: this.layoutCtrl,
                        url: Mustache.render(this.url.dashboard, { userId: 'me' }),
                        role: this.role
                    }),
            };

            this.listenTo(ctrl.calendar, 'before:route', this.onCalendarRoute);
            this.listenTo(ctrl.conversation, 'before:route', this.onConversationRoute);
            this.listenTo(ctrl.questionnaire, 'before:route', this.onQuestionnaireRoute);
            this.listenTo(ctrl.goal, 'before:route', this.onGoalRoute);
        },

        getLayoutInstance: function() {
            return new VMemberLayout({
                url: _.clone(this.url),
                role: this.role,
            });
        },

        ////////////
        // Routes //
        ////////////

        index: function(groupId, userId) {
            var redirectUrl = this.url.dashboard;

            if (localStorage.getItem('pushNotificationRedirection')) {
                var urls = JSON.parse(localStorage.getItem('pushNotificationRedirection'));
                redirectUrl = urls.member;
                localStorage.removeItem('pushNotificationRedirection');
            }
            this.redirect(Mustache.render(redirectUrl, { userId: 'me' }));
        },

        renderCalendar: function(groupId, userId) {
            this.getLayout().showMemberPage(groupId, userId, "calendar");
        },

        renderMessage: function(groupId, userId, conversationId) {
            this.getLayout().showMemberPage(groupId, userId, "message", { conversation: conversationId });
        },

        renderGoal: function(groupId, userId) {
            this.getLayout().showMemberPage(groupId, userId, "goal");
        },

        renderGraph: function(groupId, userId) {
            this.getLayout().showMemberPage(groupId, userId, "graph");
        },

        renderForum: function(groupId, userId) {
            this.getLayout().showMemberPage(groupId, userId, "forum");
        },

        onCalendarRoute: function(route, params) {
            this.renderCalendar.apply(this, params);
        },

        onQuestionnaireRoute: function(route, params) {
            var ctrl = this.ctrl.dashboard;
            ctrl.renderDashboard.apply(ctrl, params);
        },

        onGoalRoute: function(route, params) {
            var ctrl = this.ctrl.goal;
            ctrl.index.apply(ctrl, params);
        },
    });

    return MemberCtrl;

});

